import fingerprint from 'fingerprintjs2'
import { backendService } from '../services/backendService'
import {isMobile} from 'react-device-detect';

const finger = async() => { 
  const values = ["screenResolution", "availableScreenResolution"];
  const os = ["Lin", "Win", "Mac"];
  let platform = "PC-";
  if(isMobile)
    platform = "Mobile-"
   
  const object = await new Promise(resolve => {
    fingerprint.get((components) => {
      const obj = [];
      Object.keys(components).map(item => {
        if(!values.includes(components[item].key)) obj.push(components[item])        
      });
      resolve(obj)
    })
  });
  const hash = platform + fingerprint.x64hash128(object.map((pair) => { return pair.value }).join(), 31);
  return hash
}

export function doLogin({ email, password }) {
  return async dispatch => {
    try {
      dispatch({ type: 'LOGGED_LOADING' })
      dispatch({ type: 'RESET_ADMIN' })
      dispatch({ type: 'RESET_STRIPE' })
      dispatch({ type: 'RESET_ARTICLES' })
      dispatch({ type: 'RESET_RESPONSE' })
      sessionStorage.clear()
      const hash = await finger();
      delete backendService.defaults.headers.Authorization;
      const response = await backendService.post('/api/users/login/local', { hash, email, password })
      if (response) {
        const data = response.data;
        if (data.isLogged) {
          backendService.defaults.headers.Authorization = `Bearer ${data.token}`;
          dispatch({ type: 'LOGGED_IN', data })
        } else {
          dispatch({ type: 'LOGIN_FAILED', data })
        }
      } else {
        let data = {isLogged: false}
        dispatch({ type: 'LOGIN_FAILED', data })
      }
    } catch (error) {
      
      let data = { error: true, message: error.message}
      if (error.data) {
        data = error.data
        data.error = true
      }
      dispatch({ type: 'LOGIN_FAILED', data })
    }
  }
}

export function doTokenLogin({ id, token }) {
  return async dispatch => {
    try {
      dispatch({ type: 'RESET_ADMIN' })
      dispatch({ type: 'RESET_STRIPE' })
      dispatch({ type: 'RESET_ARTICLES' })
      dispatch({ type: 'RESET_RESPONSE' })
      sessionStorage.clear()
      const hash = await finger();
      delete backendService.defaults.headers.Authorization;
      const response = await backendService.post(`/api/users/login/token/${id}`, { hash, token: token });      
      const data = response.data;
      if (data.isLogged) {
        backendService.defaults.headers.Authorization = `Bearer ${data.token}`;
        dispatch({ type: 'LOGGED_IN', data })
      } else {
        dispatch({ type: 'LOGIN_FAILED', data })
      }
    } catch (error) {
      let data = error.data
      data.error = data.message
      dispatch({ type: 'LOGIN_FAILED', data })
    }
  }
}

export function resetLoginErrors () {
  return async dispatch => {
      dispatch({ type: 'LOGIN_RESET' })
  }  
}

export function alreadyLogin() {
  return async dispatch => {
    const data = JSON.parse(localStorage.getItem('user'));
    backendService.defaults.headers.Authorization = `Bearer ${data.token}`;
    dispatch({ type: 'LOGGED_IN', data })
  }
}


export function getLawyer(id) {
  return async dispatch => {
    try {
      const response = await backendService.get(`/api/lawyers/${id}`);
      const data = response.data;
      let userInfo = JSON.parse(localStorage.getItem('user'));
      userInfo = {...userInfo, user: data}
      localStorage.setItem('user', JSON.stringify(userInfo))
      dispatch({ type: 'GET_LAWYER', data })
    } catch (error) {      
      error.error = true;
      error.message = 'get_lawyer_failed';
      dispatch({ type: 'GET_LAWYER_FAILED', data: error })
    }
    setTimeout(function () {
      dispatch({ type: 'LAWYER_MESSAGE_RESET' })
    }, 5000)
  }
}

export function updateLawyer(id, lawyer) {
  return async dispatch => {
    try {
      const response = await backendService.put(`/api/lawyers/${id}`, lawyer)
      const data = response.data;
      let userInfo = JSON.parse(localStorage.getItem('user'));
      userInfo = {...userInfo, user: data}
      localStorage.setItem('user', JSON.stringify(userInfo))
      dispatch({ type: 'UPDATE_LAWYER', data })
    } catch (error) {      
      error.error = true;
      error.message = 'user_profile_update_failed';
      dispatch({ type: 'UPDATE_LAWYER_FAILED', data: error })
    }
    setTimeout(function () {
      dispatch({ type: 'LAWYER_MESSAGE_RESET' })
    }, 5000)
  }
}

export function validateToken({ email }) {
  return async dispatch => {
    try {
      const response = await backendService.post('/api/users/validateToken', { email });
      const data = response.data
      if (data.isLogged) {
        backendService.defaults.headers.Authorization = `Bearer ${data.token}`;
        dispatch({ type: 'VALIDATE_USER_SUCCESS', data })
      } else {
        delete backendService.defaults.headers.Authorization;
        const error = { message: "token is incorrect" };
        dispatch({ type: 'VALIDATE_USER_FAILED', error });
      }
    } catch (error) {
      delete backendService.defaults.headers.Authorization;
      dispatch({ type: 'VALIDATE_USER_FAILED', error })
    }
  }
}

export function sendVerificationEmail({ email }) {
  return async dispatch => {
    try {
      const response = await backendService.post('/api/lawyers/verificationEmail', { email });
      if (response.data) {
        const data = response.data
        dispatch({ type: 'VERIFY_REQ_SUCCESS', data })       
      } else {
        dispatch({ type: 'VERIFY_REQ_FAIL' })
      }
    } catch (error) {
      dispatch({ type: 'VERIFY_REQ_FAIL', error })
    }
    setTimeout(function () {
      dispatch({ type: 'VERIFY_REQ_RESET' })
    }, 5000)
  }
}

export function logout() {
  return async dispatch => {
    try {
      const response = await backendService.get('/api/dashboard/logout')
      if (response.data) {
        const data = response.data
        
        dispatch({ type: 'LOGGED_OUT', data })
        sessionStorage.clear()
      }
      else {
        const data = { error: true }
        dispatch({ type: 'LOGOUT_ERROR', data })
      }
    } catch (error) {
      dispatch({ type: 'LOGOUT_ERROR', error })
    }

  }
}

export function passRestore({ email }) {
  return async dispatch => {
    try {

      const response = await backendService.post('/api/users/login/restore', { email, path: 'user' });
      if (response.data) {
        const data = response.data
        dispatch({ type: 'RESTORE_REQ_SUCCESS', data })       
      }
      else {
        dispatch({ type: 'RESTORE_REQ_FAIL' })
      }
    } catch (error) {
      dispatch({ type: 'RESTORE_REQ_FAIL', error })
    }
    setTimeout(function () {
      dispatch({ type: 'RESTORE_REQ_RESET' })
    }, 5000)
  }
}

export function resetPassRestore() {
  return async dispatch => {    
    dispatch({ type: 'RESTORE_REQ_RESET' })    
  }
}

export function passUpdate({ email, oldPass, newPass }) {
  return async dispatch => {
    try {

      const body = {password: oldPass, newPassword: newPass}
      const response = await backendService.post(`/api/lawyers/update/password/${email}`, body)
      if (response.data) {
        const data = response.data
        dispatch({ type: 'UPDATE_REQ_SUCCESS', data })       
      }
      else {
        dispatch({ type: 'UPDATE_REQ_FAIL' })
      }
    } catch (error) {
      dispatch({ type: 'UPDATE_REQ_FAIL', error })
    }
    setTimeout(function () {
      dispatch({ type: 'UPDATE_REQ_RESET' })
    }, 5000)
  }
}

export function searchAILoadMore(searchArgs) {
  return async dispatch => {
    dispatch({ type: 'SEARCHING_MORE' })
    try {
      const { data: { data } } = await backendService.post('/api/search/', searchArgs);
      dispatch({ type: 'SEARCH_MORE_FETCHED', data })
    } catch (error) {
      const data = { error: true }
      dispatch({ type: 'SEARCH_MORE_FAILED', data })
    }
  }
}

const doCheck = async ({ user }) => {
  try {
    const hash = await finger();
    const response = await backendService.get('/api/users/login/check');
    let data = response.data;  
    return(data);
  } catch (err) {
    return({ err }) 
  }
}

export function searchAI(searchArgs) {
  return async dispatch => {
    dispatch({ type: 'SEARCHING' })
    try {
      const response = await doCheck(searchArgs.auth);

      if(response.license === false) 
        if (response.user.desired_plan_id !== null && response.user.desired_plan_id !== undefined && response.user.desired_plan_id.length === 0)
          return  dispatch({ type: 'SEARCH_FAILED', data: { free_trial_expired: true } });
        else
          return  dispatch({ type: 'SEARCH_FAILED', data: { license: false } });  
      if(response.answer === false || response.err) 
        return dispatch({ type: 'SEARCH_FAILED', data: { check: false } });  
      if(response.query === false && response.user && response.user.desired_plan_id !== null && response.user.desired_plan_id !== undefined && response.user.desired_plan_id.length === 0) 
        return  dispatch({ type: 'SEARCH_FAILED', data: { free_trial_expired: true } });   
      if(response.query === false) 
        return  dispatch({ type: 'SEARCH_FAILED', data: { query: false } });   
      
        
      const { data: { data } } = await backendService.post('/api/search/', searchArgs);
      dispatch({ type: 'SEARCH_FETCHED', data });    
    } catch (err) {
      const data = { error: true }
      dispatch({ type: 'SEARCH_FAILED', data: data })
    }
  }
}

export function searchErrorSubmit() {
  return async dispatch => {
    dispatch({ type: 'SEARCH_FAILED', data: { check: true } });
  }
}


export function getArticle({ id, article_type }) {
  return async dispatch => {
    dispatch({ type: 'GET_ARTICLE_LOADING' })
    try {
      const response = await backendService.get(`/api/articles/${article_type}/:${id}`)
      if (response.data) {
        const data = response.data
        dispatch({ type: 'GET_ARTICLE_FETCHED', data })
      }
      else {
        const data = { error: true }
        dispatch({ type: 'GET_ARTICLE_FAILED', data })
      }
    } catch (error) {

      const data = { error: true }
      dispatch({ type: 'GET_ARTICLE_FAILED', data })
    }
  }
}

export function getProducts() {
  return async dispatch => {
    try {
      const response = await backendService.get('/api/stripe/products')      
      if (response.data) {
        const data = response.data
        dispatch({ type: 'GET_PRODUCTS_SUCCESS', data })
      }
      else {
        const data = { error: true }
        dispatch({ type: 'GET_PRODUCTS_FAILED', data })
      }
    }
    catch (error) {

      const data = { error: true }
      dispatch({ type: 'GET_PRODUCTS_FAILED', data })
    }
  }
}

export function getProjects({ user, userId }) {
  return async dispatch => {
    try {
      const auth = JSON.parse(localStorage.getItem('user'));
      const customerProfile = (auth.type === 'user' || auth.user.email !== user) && await backendService.get(`/api/lawyers/${userId}/stripe_customer`);
      if ( auth.type === 'admin' || customerProfile.data) {
        const responseProjects = await backendService.get(`/api/projects?user=${user}`);
        if (responseProjects.data) {
          const data = { projects: responseProjects.data, customerProfile: customerProfile.data }
          return new Promise((resolve, reject) => {
            dispatch({ type: 'GET_FOLDERS_FETCHED', data })
            resolve()
          });
        }
        else {
          const data = { error: true }

          return new Promise((resolve, reject) => {
            dispatch({ type: 'GET_FOLDERS_FAILED', data })
            resolve()
          });
        }
      }
    } catch (error) {
      return new Promise((resolve, reject) => {
        const data = { error: true }
        dispatch({ type: 'GET_FOLDERS_FAILED', data })
        resolve()
      });
    }
  }
}

export function pushFolder({ user, name, description, projectelement }) {
  return async dispatch => {
    try {
      const response = await backendService.post('/api/projects', { user, name, description, projectelement });
      if (response.data) {
        const data = response.data
        return new Promise((resolve, reject) => {
          dispatch({ type: "PUSH_FOLDER_FETCHED", data });
          resolve()
        });
      }
      else {
        const data = { error: true }

        return new Promise((resolve, reject) => {
          dispatch({ type: "PUSH_FOLDER_FAILED", data });
          resolve()
        });
      }
    } catch (error) {
      return new Promise((resolve, reject) => {
        const data = { error: true }
        dispatch({ type: "PUSH_FOLDER_FAILED", data });
        resolve()
      });
    }
  }
}

export function pushFeedback({ user, idResult, query, result, positive, comment }) {
  return async dispatch => {
    try {
      const response = await backendService.post('/api/feedbacks', { user, idResult, query, result, positive, comment });
      if (response.data) {
        const data = response.data
        return new Promise((resolve, reject) => {
          dispatch({ type: "PUSH_FEEDBACK_FETCHED" });
          resolve()
        });
      }
      else {
        const data = { error: true }

        return new Promise((resolve, reject) => {
          dispatch({ type: "PUSH_FEEDBACK_FAILED", data });
          resolve()
        });
      }
    } catch (error) {
      return new Promise((resolve, reject) => {
        const data = { error: true }
        dispatch({ type: "PUSH_FEEDBACK_FAILED", data });
        resolve()
      });
    }
  }
}



export function delFeedback({ user, idResult }) {
  return async dispatch => {
    try {
      const response = await backendService.delete(`/api/feedbacks?user=${user}&idResult=${idResult}`)
      if (response.data) {
        const data = response.data
        return new Promise((resolve, reject) => {
          dispatch({ type: "DELETE_FEEDBACK_FETCHED" });
          resolve()
        });
      }
      else {
        const data = { error: true }
        return new Promise((resolve, reject) => {
          dispatch({ type: "DELETE_FEEDBACK_FAILED", data });
          resolve()
        });
      }
    } catch (error) {
      return new Promise((resolve, reject) => {
        const data = { error: true }
        dispatch({ type: "DELETE_FEEDBACK_FAILED", data });
        resolve()
      });
    }
  }
}



export function getFeedbacks({ user, idResult }) {
  return async dispatch => {
    dispatch({ type: 'GET_FEEDBACKS_LOADING' })
    try {
      const response = await backendService.get(`/api/feedbacks?user=${user}&idResult=${idResult}`);
      if (response.data) {
        if (response.data.positive === true) {
          const data = { feedback: 'positive' }
          return new Promise((resolve, reject) => {
            dispatch({ type: 'GET_FEEDBACK_FETCHED', data })
            resolve()
          });
        } else if (response.data.positive === false) {
          const data = { feedback: 'negative' }
          return new Promise((resolve, reject) => {
            dispatch({ type: 'GET_FEEDBACK_FETCHED', data })
            resolve()
          });
        }

      }
      else {
        const data = { feedback: 'none' }
        return new Promise((resolve, reject) => {
          dispatch({ type: 'GET_FEEDBACK_FAILED', data })
          resolve()
        });
      }
    } catch (error) {
      const data = { error: true }
      return new Promise((resolve, reject) => {
        dispatch({ type: 'GET_FEEDBACK_FAILED', data })
        resolve()
      });
    }
  }
}


export function pushElement({projectId, projectelement }) {
  return async dispatch => {
    try {
      const response = await backendService.post('/api/projects/' + projectId + '/elements', { projectelement })
      if (response.data) {
        const data = response.data
        return new Promise((resolve, reject) => {
          dispatch({ type: "PUSH_ELEMENT_FETCHED" });
          resolve()
        });
      }
      else {
        const data = { error: true }

        return new Promise((resolve, reject) => {
          dispatch({ type: "PUSH_ELEMENT_FAILED", data });
          resolve()
        });
      }
    } catch (error) {
      return new Promise((resolve, reject) => {
        const data = { error: true }
        dispatch({ type: "PUSH_ELEMENT_FAILED", data });
        resolve()
      });
    }
  }
}


export function resetResponse() {
  return async dispatch => {
    dispatch({ type: 'RESET_RESPONSE' })
  }
}